export default __webpack_public_path__ + "static/media/36.40616e38.png";